export const PASSION_GRID_LAYOUT_CONSTANTS = {
  MAX_SCAN: 50,
  PLACEHOLDER_HEADING: 'A Platform For Every Passion',
  DEFAULT_SUBHEADING:
    'Our white-labeled fan engagement platform offers tools that allow creators and renowned global sports and entertainment brands to take back control.',
  DEFAULT_CTA_LABEL: 'Learn More',
  DEFAULT_ALT_CARD_IMAGE: 'Passion card image',
  DEFAULT_CARD_TITLES: [
    'For Music Bands',
    'For Sports Teams',
    'For Associations & Alumni',
    'For Influencers',
    'For Podcasters',
    'For Creators',
    'For Music Artists',
    'For Musicians'
  ] as readonly string[],
  LAYOUT_LABEL: 'Image Cards Grid',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1785240608456.png',
  LAYOUT_DESCRIPTION:
    'Multi-card grid with heading, subheading, image cards, descriptions and CTA links'
} as const;
